import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import {
    FormBuilder,
    FormGroup,
    FormsModule,
    ReactiveFormsModule,
    Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { Button, ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { InputTextModule } from 'primeng/inputtext';
import { MessagesModule } from 'primeng/messages';
import { languages } from 'src/app/demo/constants/languages';
import { LanguageService } from 'src/app/demo/service/language.service';
import { ProgressLoaderService } from 'src/app/demo/service/progress-loader.service';
import { VehicleMakesService } from 'src/app/demo/service/vehicle-makes.service';
import { showErrorToast } from 'src/app/demo/utilities/toast-utils';
import { NgxTranslateModule } from 'src/app/translate.module';

@Component({
    selector: 'app-add-vehicle-make',
    standalone: true,
    imports: [
        CommonModule,
        ButtonModule,
        InputTextModule,
        CardModule,
        NgxTranslateModule,
        MessagesModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    templateUrl: './add-vehicle-make.component.html',
    styleUrl: './add-vehicle-make.component.scss',
    providers: [MessageService],
})
export class AddVehicleMakeComponent {

    vehicleMakeForm!: FormGroup;
    languages: any[] = languages;
    selectedLanguage!: string;

    constructor(
        private messageService: MessageService,
        private fb: FormBuilder,
        private languageService: LanguageService,
        private translateService: TranslateService,
        private vehicleMakeService: VehicleMakesService,
        private progressLoader: ProgressLoaderService,
        private router: Router
    ) { }

    ngOnInit() {
        this.createMakeForm();
        this.initializeLocale();
    }

    createMakeForm() {
        this.vehicleMakeForm = this.fb.group({
            name: ['', Validators.required],
        });
    }

    backToVehicleMakes() {
        this.router.navigate(['/home/vehicle-makes']);
    }

    initializeLocale() {
        this.languageService.currentLanguage$.subscribe((language) => {
            this.selectedLanguage = language;
            this.setLanguage(this.selectedLanguage);
        });
    }

    setLanguage(language: string) {
        this.translateService.use(language);
        this.languageService.setLanguage(language);
    }

    saveMake() {
        this.progressLoader.show()
        this.vehicleMakeService
            .createVehicleMake(this.vehicleMakeForm.value)
            .subscribe({
                next: (value) => {
                    this.progressLoader.hide();
                    this.translateService.get("VEHICLE_MAKE_CREATED_SUCCESS").subscribe(result => {
                        this.showSuccessToast(result);
                    })
                },
                error: (err) => {
                    showErrorToast(this.translateService.instant(err.error.messageKey), this.messageService,this.translateService)
                    this.progressLoader.hide();
                },
            });
    }

    showSuccessToast(message: string) {
        this.translateService.get(['Success', message]).subscribe(translations => {
            this.messageService.add({
                severity: 'success',
                summary: translations['Success'],
                life: 2000,
                detail: translations.get(message),
                key: 'tc',
            });
        })
    }

    showErrorToast(error: string) {
        this.translateService.get(['Error', error]).subscribe(translations => {
            this.messageService.add({
                severity: 'error',
                summary: translations['Error'],
                life: 2000,
                detail: translations.get(error),
                key: 'tc',
            });
        })
    }

    backClicked() {
        this.vehicleMakeForm.reset();
        this.router.navigate(['/home/vehicle-makes'])
    }
}
